import { useMutation } from '@tanstack/react-query';

import { PostPasswordPayload, PostPasswordResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';

export const postPassword = (payload: PostPasswordPayload): Promise<PostPasswordResponse> => {
    return axios.post('/profile/change-password', payload);
};

type UsePostPasswordOptions = {
    config?: MutationConfig<typeof postPassword>;
    data?: PostPasswordPayload;
};

export const usePostPassword = ({ config }: UsePostPasswordOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postPassword,
    });
};
